import { ApiAnnotation, HighlightColorClass, HighlightShapeClass } from '@mhe/reader/models';
import { HighlightColor, HighlightShape, OptionsPane } from '../annotations-context-menu.model';

export interface AnnotationsContextMenuState {
  annotation: ApiAnnotation | null
  color: HighlightColor | null
  shape: HighlightShape | null
  colorOptions: HighlightColor[]
  lastOrDefaultHighlightColorSelected: HighlightColorClass
  lastHighlightShapeSelected: HighlightShapeClass | undefined
  visibleOptionsPane: OptionsPane | null
  noteMaxCharacters: number
}

export const initialAnnoationsContextMenuState: AnnotationsContextMenuState = {
  annotation: null,
  color: null,
  shape: null,
  lastOrDefaultHighlightColorSelected: 'yellow-highlight',
  lastHighlightShapeSelected: undefined,
  colorOptions: ['yellow', 'green', 'blue', 'pink'],
  visibleOptionsPane: null,
  noteMaxCharacters: 3500,
};
